import React from "react"
import Footer from "../components/Footer"
import Header from "../components/Header"
import SecondaryResourcesCategoryView from "./SecondaryResourcesCategoryView"
import Secondary3TBL from "../images/secondary-3-literary.png"
import Secondary3TBS from "../images/secondary-3-science.png"
import ZipLogo from "../images/zip.svg"

class Secondary3Resources extends React.Component {
  state = {
    view: {
      title: "Secondary 3 Resources",
      parentURL: "/resources",
      parentName: "resources",
      categories: [
        {
          name: "Teacher's Book",
          file: Secondary3TBL,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G12-Secondary-3-Literary-TB_WM_2022.pdf",
          file2: Secondary3TBS,
          filePath2:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/resources-nov-2022/G12-Secondary-3-Science-TB_WM_2022.pdf",
        },
        {
          name: "Audio",
          fileType: ZipLogo,
          filePath:
            "https://d2eynxry1y23ue.cloudfront.net/Libya-assets/audio-april-2022/",
          files: [
            {
              name: "Secondary 3 Audio (Literary)",
              file: "Secondary-3-audio-(Literary).zip",
            },
            {
              name: "Secondary 3 Audio (Science)",
              file: "Secondary-3-audio-(Science).zip",
            },
          ],
        },
      ],
    },
  }

  render() {
    return (
      <div>
        <Header />

        <SecondaryResourcesCategoryView data={this.state.view} />

        <Footer />
      </div>
    )
  }
}

export default Secondary3Resources



// WEBPACK FOOTER //
// ./src/components/ResourcesSecondary3.js